import { useContext, useEffect, useRef } from "react";
import { MessageContext } from "../context/MessageContext";

function ToastMessage() {
  const { message, type, showMessage } = useContext(MessageContext);
  const toastRef = useRef(null);

  useEffect(() => {
    if (message && window.bootstrap) {
      const toast = new window.bootstrap.Toast(toastRef.current);
      toast.show();
    }
  }, [message]);

  if (!message) return null;


  return (
    <div className="toast-container position-fixed top-0 end-0 p-3">
      <div
        ref={toastRef}
        className="toast show shadow-lg rounded-3 border-0"
        role="alert"
      >
        <div
          className={`d-flex align-items-center text-bg-${type} bg-opacity-75 rounded-3 px-3 py-2`}
        >
          {/* Icon */}
          <div className="me-2 flex-shrink-0">
            {type === "success" && (
              <i className="bi bi-check-circle-fill fs-5"></i>
            )}
            {type === "danger" && (
              <i className="bi bi-x-circle-fill fs-5"></i>
            )}
            {type === "info" && (
              <i className="bi bi-info-circle-fill fs-5"></i>
            )}
            {type === "warning" && (
              <i className="bi bi-exclamation-triangle-fill fs-5"></i>
            )}
          </div>

          {/* Message */}
          <div className="flex-grow-1">
            <div className="fw-semibold lh-sm">
              {type === "success" && "Success"}
              {type === "danger" && "Error"}
              {type === "info" && "Info"}
              {type === "warning" && "Warning"}
            </div>
            <div className="small opacity-75 lh-sm">
              {message}
            </div>
          </div>

          {/* Close */}
          <button
            type="button"
            className="btn-close btn-close-white ms-3"
            onClick={() => showMessage(null)}
          ></button>
        </div>
      </div>
    </div>
  );
}

export default ToastMessage;
